































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { FORM101_DATA, OPEN_FORM_101_CHANGES_DIALOG, SET_OPEN_FORM_101_CHANGES_DIALOG } from '@/types/form.types';
import {
  FORM101_CHANGES,
  FORM101_SECTION_NAMES,
  FORM101_SECTION_NOTES,
  FORM_101_CHANGES_NOTES_ERRORS, GENERATE_FORM_CHANGES_REPORT, MANAGER_LOADING,
  SAVE_FORM_101_CHANGES_NOTES,
} from '@/types/managerForm.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { GridColumn } from '@/models/GridColumn.model';
import Spinner from '@/components/loading/Spinner.vue';

@Component({
  components: {
    Spinner,
  },
})
export default class Form101ChangesModal extends Vue {

  @Action(SAVE_FORM_101_CHANGES_NOTES, StoreNamespace.MANAGER) public saveForm101ChangesNotes;
  @Action(GENERATE_FORM_CHANGES_REPORT, StoreNamespace.MANAGER) public generateFormChangesReport;

  @Mutation(SET_OPEN_FORM_101_CHANGES_DIALOG, StoreNamespace.FORM) public setOpenForm101ChangesDialog;

  @Getter(OPEN_FORM_101_CHANGES_DIALOG, StoreNamespace.FORM) public openForm101ChangesDialog!: boolean;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(FORM101_CHANGES, StoreNamespace.MANAGER) public form101Changes!: any;
  @Getter(FORM101_SECTION_NAMES, StoreNamespace.MANAGER) public form101SectionNames!: any;
  @Getter(FORM101_SECTION_NOTES, StoreNamespace.MANAGER) public sectionNotes!: any;
  @Getter(FORM_101_CHANGES_NOTES_ERRORS, StoreNamespace.MANAGER) public serverErrorMessages!: string[];
  @Getter(MANAGER_LOADING, StoreNamespace.MANAGER) public managerLoading!: boolean;

  @Prop(Boolean)
  public showNotes!: boolean;

  @Prop(Boolean)
  public showView!: boolean;

  private columns: GridColumn[] = [];

  public closeDialog(): void {
    this.setOpenForm101ChangesDialog(false);
  }

  public noteBlur(note: string, sectionId: string) {
    if (note) {
      this.saveForm101ChangesNotes({
        formId: this.form101Data.formId,
        officeNum: this.form101Data.officeNum,
        idNum: this.form101Data.idNum,
        positionNum: this.form101Data.positionNum,
        sectionCode: Number(sectionId.slice(8)),
        notes: note,
      });
    }
  }

  public onGenerateReportClicked() {
    this.generateFormChangesReport({
      formId: this.form101Data.formId,
      officeNum: this.form101Data.officeNum,
      idNum: this.form101Data.idNum,
      positionNum: this.form101Data.positionNum,
    });
  }

  public onViewClicked(key: string, sectionName: number) {
    this.setOpenForm101ChangesDialog(false);
    this.$emit('onViewClicked', key, sectionName);
  }

  public destroyed() {
    this.setOpenForm101ChangesDialog(false);
  }

}
